import React from 'react';
import { AlertTriangle, CalendarCheck, FileSpreadsheet, ScanLine } from 'lucide-react';

const source = (c) => {
  if (c.app > 0) return { label: `App / eSSL · ${c.app} staff-days`, Icon: CalendarCheck, cls: 'bg-emerald-50 text-emerald-700 border-emerald-200' };
  if (c.sheet > 0) return { label: `P / A sheet · ${c.sheet} staff-days`, Icon: FileSpreadsheet, cls: 'bg-sky-50 text-sky-700 border-sky-200' };
  if (c.scans_only > 0) return { label: 'No attendance — scan days only', Icon: ScanLine, cls: 'bg-amber-50 text-amber-800 border-amber-200' };
  return { label: 'No data', Icon: AlertTriangle, cls: 'bg-gray-50 text-gray-500 border-gray-200' };
};

/** Where each month's days present come from (app / eSSL punches, the uploaded P/A sheet, or scan days only). */
export const CoverageStrip = ({ months }) => (
  <div className="mb-4" data-testid="rank-coverage">
    <div className="flex flex-wrap gap-2">
      {months.map((m) => {
        const c = m.coverage || {};
        const s = source(c);
        return (
          <div key={m.key} className={`inline-flex items-center gap-1.5 rounded-full border px-3 py-1 text-xs font-medium ${s.cls}`}
            title={`${c.app || 0} staff-days from app / eSSL · ${c.sheet || 0} from the P/A sheet · ${c.scans_only || 0} with scans but no attendance${c.no_scans ? ` · ${c.no_scans} present with no scans in any operation` : ''}`}
            data-testid={`rank-coverage-${m.key}`}>
            <s.Icon className="w-3.5 h-3.5" /><span className="font-semibold">{m.label}</span> · {s.label}
          </div>
        );
      })}
    </div>
    <p className="text-xs text-gray-500 mt-2">Days with scans count as present. Hours use approved In → Out times; days without times count 8 h (marked ~). A day spent on two operations is split by the time on each.</p>
  </div>
);

export default CoverageStrip;
